// Subtle parallax: elements with [data-parallax] shift slower than the scroll,
// giving a gentle depth effect. data-parallax holds the speed factor (0–1).
export default function initParallax() {
    const els = document.querySelectorAll('[data-parallax]');

    if (!els.length) {
        return;
    }

    // Respect users who prefer reduced motion.
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return;
    }

    let ticking = false;

    const update = () => {
        const y = window.scrollY || window.pageYOffset;
        els.forEach((el) => {
            const speed = parseFloat(el.dataset.parallax) || 0.15;
            el.style.transform = `translate3d(0, ${(y * speed).toFixed(1)}px, 0)`;
        });
        ticking = false;
    };

    window.addEventListener(
        'scroll',
        () => {
            if (!ticking) {
                window.requestAnimationFrame(update);
                ticking = true;
            }
        },
        {passive: true}
    );

    update();
}
